import { StatisticColorByStepCalc } from '@app/utils/statistic-color-by-step';
import { ApexOptions } from 'apexcharts';
import React from 'react';

import ApexChart from 'react-apexcharts';

export const MonitoringScoreDiagram = ({
  score,
  height = 250,
  width,
  maxScore,
  fontSize,
  formatting,
}: {
  score: number;
  maxScore: number;
  formatting?: {
    color: string;
    value: number[];
    desc: string;
    count: number;
    pct: number;
  }[];
  height?: number;
  width?: number;
  fontSize?: string;
}) => {
  const fillScore = Number(Math.min((score / maxScore) * 100, 100).toFixed(1)) || 0;
  const standardColor = StatisticColorByStepCalc({ max: maxScore, score: score });
  function colorByFormatting() {
    return formatting?.find(({ value }) => {
      return value[0] <= score && score <= value[1];
    })?.color;
  }

  const options: ApexOptions = {
    chart: {
      type: 'radialBar',
      animations: { enabled: false },
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -125,
        endAngle: 235,
        hollow: {
          margin: 0,
          size: '35%',
          background: '#fff',
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: 'front',
        },
        dataLabels: {
          show: true,
          name: {
            show: true,
            offsetY: 5,
            color: '#888',
            fontSize: fontSize || '17px',
            fontWeight: 900,
          },
          value: { show: false },
        },
      },
    },
    fill: {
      colors: [formatting ? colorByFormatting() || standardColor : standardColor],
    },
    stroke: {
      lineCap: 'square',
    },
    labels: [score.toString()],
  };

  return (
    <ApexChart
      type="radialBar"
      height={height}
      width={width}
      series={[fillScore]}
      options={options}
    />
  );
};
